export const environment = {
  apiUrl: 'https://api-tracking.goodwillfreight.com',
  appUrl: 'https://tracking.goodwillfreight.com'
};
